export const OTP_LENGTH = 6;

export function normalizeOtp(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, OTP_LENGTH);
}

export function isCompleteOtp(value: string): boolean {
  return /^\d{6}$/.test(value);
}
